import { useEffect } from "react";
import Header from "@/sections/Header";
import Primer from "@/sections/Primer";
import Ecosystem from "@/sections/Ecosystem";
import InfrastructureOverview from "@/sections/InfrastructureOverview";
import Audience from "@/sections/Audience";
import Press from "@/sections/Press";
import TalentInTech from "@/sections/TalentInTech";
import FooterSection from "@/sections/Footer";

export default function ExplorePage() {
  // Handle in-page anchor scrolling after mount (React Router doesn't do this natively)
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        // Delay so layout is ready
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
      }
    }
  }, []);

  return (
    <main data-testid="explore-page" className="relative">
      <Header />
      <div className="pt-7 md:pt-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
          <div className="font-mono-label text-[11px] tracking-[0.18em] text-[#71747B] uppercase">
            / Explore
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-extrabold text-[#0F1117] text-balance mt-4">
            <span className="text-chrome">The full DCYB picture.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-[#3D4049]">
            The people, the ecosystem, the press coverage, and the primer that grounds
            the DCYB thesis. Everything beyond the front page.
          </p>
        </div>
      </div>
      <Primer />
      <Ecosystem />
      <InfrastructureOverview />
      <Audience />
      <Press />
      <TalentInTech />
      <FooterSection />
    </main>
  );
}
